import { useFetchGetById } from "@/shared/actions/erp";
import { CircularProgress, Grid, Typography } from "@mui/material";

type TypographyFetch = {
  label: string
  id: string
  entidad: string
}


export const TypographyFetch = ({
  label,
  id,
  entidad
}: TypographyFetch) => {

  const { 
    data, 
    isLoading
   } = useFetchGetById<any>(entidad, id);

  if (isLoading) {
    return <CircularProgress />
  }

  return (
    <Grid item xs={12} sm={4}>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
      <Typography variant="body2" fontWeight={500}>{data?.nombre || '-'}</Typography>
    </Grid>
  );
};